export default "__VITE_ASSET__vujuUTbO__"